var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconProperty = function SvgIconProperty(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5,4 L6,4 L6,0.5 C6,0.225 5.775,0 5.5,0 L4.5,0 C4.225,0 4,0.225 4,0.5 L4,4 L0.5,4 C0.225,4 0,4.225 0,4.5 L0,5.5 C0,5.775 0.225,6 0.5,6 L4,6 L4,31.5 C4,31.775 4.225,32 4.5,32 L5.5,32 C5.775,32 6,31.775 6,31.5 L6,6 L12,6 L12,9 L11,9 C9.89375,9 9,9.89375 9,11 L9,22 C9,23.10625 9.89375,24 11,24 L29,24 C30.10625,24 31,23.10625 31,22 L31,11 C31,9.89375 30.10625,9 29,9 L28,9 L28,6 L31.5,6 C31.775,6 32,5.775 32,5.5 L32,4.5 C32,4.225 31.775,4 31.5,4 Z M29,22 L11,22 L11,11 L29,11 L29,22 Z M26,9 L14,9 L14,6 L26,6 L26,9 Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconProperty, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-property.899e2087.svg";
export { ForwardRef as ReactComponent };